import api, { unwrap } from './client';

// ── Scénarios ───────────────────────────────────────────────────────────────

export const listScenarios   = (tid)          => unwrap(api.get(`/treasury/scenarios/${tid}`));
export const getScenario     = (tid, sid)     => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}`));
export const createScenario  = (tid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}`, payload));
export const updateScenario  = (tid, sid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}`, payload));
export const deleteScenario  = (tid, sid)     => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}`));
export const snapshotScenario = (tid, sid, name) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/snapshot`, name ? { name } : {}));
export const duplicateScenario = (tid, sid, name) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/duplicate`, name ? { name } : {}));
export const lockScenario    = (tid, sid)     => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/lock`));
export const unlockScenario  = (tid, sid)     => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/unlock`));
export const resetScenario   = (tid, sid)     => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/reset`));

// ── Lignes de revenus ───────────────────────────────────────────────────────

export const listRevenues   = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/revenues`));
export const createRevenue  = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/revenues`, payload));
export const updateRevenue  = (tid, sid, rid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/revenues/${rid}`, payload));
export const deleteRevenue  = (tid, sid, rid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/revenues/${rid}`));

// ── Postes ouverts (pilotés par le bilan, planifiés par compte) ───────────
// Une position = un compte du plan comptable : inclusion + profil de
// réalisation 12 mois. Le montant n'est pas stocké, il est lu en direct dans
// le bilan (solde du mois précédant le début du plan). Rattachés au couple
// (tenant, année) — partagés par tous les scénarios démarrant cette année.

export const listOpeningPositions  = (tid, year)          => unwrap(api.get(`/treasury/opening-positions/${tid}/${year}`));
export const upsertOpeningPosition = (tid, year, payload) => unwrap(api.put(`/treasury/opening-positions/${tid}/${year}`, payload));
export const createManualPosition  = (tid, year, payload) => unwrap(api.post(`/treasury/opening-positions/${tid}/${year}/manual`, payload));
export const updateManualPosition  = (tid, year, pid, payload) => unwrap(api.put(`/treasury/opening-positions/${tid}/${year}/${pid}`, payload));
export const deleteOpeningPosition = (tid, year, pid)     => unwrap(api.delete(`/treasury/opening-positions/${tid}/${year}/${pid}`));

// ── Charges variables (Section A %CA + Section B manuel) ───────────────────

export const listVariableExpenses   = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/variable-expenses`));
export const createVariableExpense  = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/variable-expenses`, payload));
export const updateVariableExpense  = (tid, sid, eid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/variable-expenses/${eid}`, payload));
export const deleteVariableExpense  = (tid, sid, eid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/variable-expenses/${eid}`));

// Indirect costs ont migré vers une table centrale tenant × year — voir api/indirectCosts.js

// ── Charges ponctuelles (one-off) ──────────────────────────────────────────

export const listOneOffExpenses  = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/one-off-expenses`));
export const createOneOffExpense = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/one-off-expenses`, payload));
export const updateOneOffExpense = (tid, sid, eid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/one-off-expenses/${eid}`, payload));
export const deleteOneOffExpense = (tid, sid, eid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/one-off-expenses/${eid}`));

// ── Variations de personnel ────────────────────────────────────────────────

export const listPayrollChanges  = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/payroll-changes`));
export const createPayrollChange = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/payroll-changes`, payload));
export const updatePayrollChange = (tid, sid, pid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/payroll-changes/${pid}`, payload));
export const deletePayrollChange = (tid, sid, pid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/payroll-changes/${pid}`));

// ── Primes / jetons ────────────────────────────────────────────────────────

export const listBonuses  = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/bonuses`));
export const createBonus  = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/bonuses`, payload));
export const updateBonus  = (tid, sid, bid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/bonuses/${bid}`, payload));
export const deleteBonus  = (tid, sid, bid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/bonuses/${bid}`));

// ── Taux de cotisations sociales ───────────────────────────────────────────

export const listSocialRates  = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/social-rates`));
export const createSocialRate = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/social-rates`, payload));
export const updateSocialRate = (tid, sid, rid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/social-rates/${rid}`, payload));
export const deleteSocialRate = (tid, sid, rid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/social-rates/${rid}`));

// ── Assurances ─────────────────────────────────────────────────────────────

export const listInsurances  = (tid, sid)         => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/insurances`));
export const createInsurance = (tid, sid, payload) => unwrap(api.post(`/treasury/scenarios/${tid}/${sid}/insurances`, payload));
export const updateInsurance = (tid, sid, iid, payload) => unwrap(api.patch(`/treasury/scenarios/${tid}/${sid}/insurances/${iid}`, payload));
export const deleteInsurance = (tid, sid, iid)    => unwrap(api.delete(`/treasury/scenarios/${tid}/${sid}/insurances/${iid}`));

// ── Import / Export JSON ───────────────────────────────────────────────────

export const exportScenarioJson = (tid, sid) => unwrap(api.get(`/treasury/scenarios/${tid}/${sid}/export-json`));

export const importScenarioJson = (tid, file) => {
  const form = new FormData();
  form.append('file', file);
  return unwrap(api.post(`/treasury/scenarios/${tid}/import-json`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
};

/* Ventes 12MR — mêmes données, préfixe ouvert au périmètre `sales` : l'écran du
   vendeur ne lit que le chiffre d'affaires du scénario (cf. sales_forecast.py). */
export const sfListScenarios = (tid) => unwrap(api.get(`/sales-forecast/${tid}/scenarios`));
export const sfListRevenues = (tid, sid) => unwrap(api.get(`/sales-forecast/${tid}/${sid}/revenues`));
export const sfListVariableExpenses = (tid, sid) =>
  unwrap(api.get(`/sales-forecast/${tid}/${sid}/variable-expenses`));
export const sfCreateRevenue = (tid, sid, payload) =>
  unwrap(api.post(`/sales-forecast/${tid}/${sid}/revenues`, payload));
export const sfPatchRevenue = (tid, sid, rid, payload) =>
  unwrap(api.patch(`/sales-forecast/${tid}/${sid}/revenues/${rid}`, payload));
export const sfDeleteRevenue = (tid, sid, rid) =>
  unwrap(api.delete(`/sales-forecast/${tid}/${sid}/revenues/${rid}`));
